import types from 'constants/SessionConstants';
import Immutable from 'immutable';

const initialState = Immutable.fromJS({
   config: [
    //mornShift:
    {
      startAt: '00:00',
      endAt: '00:00',
      ableAt: '00:00',
      disableAt: '00:00',
      workUnit: '0',
    },
    //aftnShift:
    {
      startAt: '00:00',
      endAt: '00:00',
      ableAt: '00:00',
      disableAt: '00:00',
      workUnit: '0',
    },
    //OTConfig:
    {
      startAt: '00:00',
      endAt: '00:00',
      ableAt: '00:00',
      disableAt: '00:00',
      minPerShift: '00:00',
      workUnitPerShift: '0',
      minWorkTime: '00:00',
    }
  ]
});

function timeToMins(time) {
  if (typeof time === 'string' && time.includes(':')){
    let [hours, mins] = time.split(":");
    return  +hours * 60 + +mins;
  } else
    return time
}

export default function(state = initialState, action) {
	switch (action.type) {
		case types.REFRESH_SESSION:
      let {sessionConfig} = action;
      sessionConfig[2].minPerShift = timeToMins(sessionConfig[2].minPerShift);
      sessionConfig[2].minWorkTime = timeToMins(sessionConfig[2].minWorkTime);
			return state.set('config', Immutable.fromJS(sessionConfig));

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/Session.js